<footer id="st-main-footer" class="footer-container" [ngClass]="{'dark-mode': is_dark}" *ngIf="showFooter && false">
  <div id="st-footer-content-wrapper" class="footer-content">
    <!-- Left Section: Logo, Contact Info, Social Media -->
    <div id="st-footer-left-column" class="footer-left">
      <!-- Logo -->
      <button type="button" (click)="openHome()" (keydown.enter)="openHome()" (keydown.space)="$event.preventDefault(); openHome()" id="st-footer-logo-1" class="footer-logo" style="cursor: pointer;">
        <div id="st-container-2" class="d-flex align-items-center">
          <img alt="" *ngIf="!is_dark"
            [ngClass]="{'pe-0': tenant_name == 'ttfi', 'p-0 switz_logo_config': tenant_name == 'switz'}"
            [attr.width]="tenant_name == 'ettu' ? '180' : (tenant_name == 'sbtf' ? '100' : (tenant_name == 'switz' ? '254' : '130'))"
            [src]="tenant_name == 'switz' ? logo_light : logo_dark" [alt]="tenantName + ' Logo'" class="logo-image" />
          <img alt="" *ngIf="is_dark"
            [ngClass]="{'pe-0': tenant_name == 'ttfi', 'p-0 switz_logo_config': tenant_name == 'switz'}"
            [attr.width]="tenant_name == 'ettu' ? '180' : (tenant_name == 'sbtf' ? '100' : (tenant_name == 'switz' ? '254' : '130'))"
            [src]="logo_light" [alt]="tenantName + ' Logo'" class="logo-image" />
          <img *ngIf="tenant_name == 'ttfi' && !is_dark" [src]="logo_dark" alt="logo" width="130" height="40" />
          <img *ngIf="tenant_name == 'ttfi' && is_dark" [src]="logo_light" alt="logo" width="130" height="40" />
        </div>
      </button>

      <!-- Contact Information - Visible for all, content conditional -->
      <div id="st-footer-contact-info" class="footer-contact">
        <div id="st-contact-item-3" class="contact-item">
          <i class="bi bi-telephone-fill contact-icon"></i>
          <span class="contact-text">{{ supportPhone }}</span>
        </div>
        <div id="st-contact-item-4" class="contact-item">
          <i class="bi bi-envelope-fill contact-icon"></i>
          <span class="contact-text">{{ supportEmail }}</span>
        </div>
        <div id="st-contact-item-5" class="contact-item">
          <i class="bi bi-globe contact-icon"></i>
          <a [href]="websiteUrl" target="_blank" rel="noopener noreferrer" class="contact-text contact-link">{{
            websiteUrl }}</a>
        </div>
      </div>

      <!-- Social Media Icons -->
      <div id="st-footer-social-links" class="footer-social">
        <a [href]="socialLinks.facebook" target="_blank" rel="noopener noreferrer" class="social-icon"
          aria-label="Facebook">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
        <a [href]="socialLinks.instagram" target="_blank" rel="noopener noreferrer" class="social-icon"
          aria-label="Instagram">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>
        <a [href]="socialLinks.tiktok" target="_blank" rel="noopener noreferrer" class="social-icon"
          aria-label="TikTok">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.59 6.69a4.83 4.83 0 0 1-1.19-.15 5.5 5.5 0 0 1-1.19-.38v4.05a6.07 6.07 0 0 1-6.13 6.13 6.07 6.07 0 0 1-6.13-6.13 6.07 6.07 0 0 1 6.13-6.13c.34 0 .67.03 1 .08v2.63a3.33 3.33 0 0 0-1-.15 3.5 3.5 0 0 0-3.5 3.5 3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 0 3.5-3.5V2.5h2.5a4.83 4.83 0 0 0 4.5 4.19z" />
          </svg>
        </a>
      </div>

      <!-- Copyright Notice -->
      <div id="st-footer-copyright-notice" class="footer-copyright">
        <p>
          © Copyright {{ currentYear }} STUPA. All Rights Reserved.
          No part of this site may be reproduced, stored in a retrieval system or transmitted
          in any way or by any means (including photocopying, recording or storing it in any
          medium by electronic means), without the written permission of STUPA.
        </p>
      </div>
    </div>

    <!-- Right Section: Navigation Links -->
    <div id="st-footer-right-column" class="footer-right">
      <div id="st-footer-navigation-links" class="footer-links">
        <a [href]="navigationLinks.aboutUs" target="_blank" rel="noopener noreferrer" class="footer-link">{{
          'footer.about_us' | translate }}</a>
        
        
        <a href="https://www.swisstennis.ch/de/verband/agb/" target="_blank" rel="noopener noreferrer"
          class="footer-link">Terms and Conditions (German)</a>
        <a href="https://www.swisstennis.ch/fr/federation/cgc/" target="_blank" rel="noopener noreferrer"
          class="footer-link">Terms and Conditions (French)</a>
        <a href="{{commonStorageUrl}}/switz/Datenschutzerkla%CC%88rung_Swiss%20Tennis_v032025%20(1).pdf"
          target="_blank" rel="noopener noreferrer" class="footer-link">Privacy Policy (German)</a>
        <a href="{{commonStorageUrl}}/switz/De%CC%81claration%20de%20protection%20des%20donne%CC%81es_Swiss%20Tennis_v032025%20(1).pdf"
          target="_blank" rel="noopener noreferrer" class="footer-link">Privacy Policy (French)</a>
        
      </div>

      <!-- Powered By Section -->
      <div id="st-footer-powered-by" class="footer-powered-by">
        <span class="powered-by-text">{{ 'footer.powered_by' | translate }}</span>
        <div id="st-stupa-logo-6" class="stupa-logo">
          <img src="assets/logo/stupa-new-logo.png" alt="STUPA Logo" class="stupa-logo-image" />
        </div>
      </div>
    </div>
  </div>

  <!-- Copyright Notice - Full Width at Bottom (Mobile Only) -->
  <div id="st-footer-mobile-copyright" class="footer-copyright-mobile">
    <p>
      © Copyright {{ currentYear }} STUPA. All Rights Reserved.
      No part of this site may be reproduced, stored in a retrieval system or transmitted
      in any way or by any means (including photocopying, recording or storing it in any
      medium by electronic means), without the written permission of STUPA.
    </p>
  </div>

  <!-- Powered By Section - Very Bottom (Mobile Only) -->
  <div id="st-footer-mobile-powered-by" class="footer-powered-by-mobile">
    <span class="powered-by-text">{{ 'footer.powered_by' | translate }}</span>
    <div id="st-stupa-logo-7" class="stupa-logo">
      <img src="assets/logo/stupa-new-logo.png" alt="STUPA Logo" class="stupa-logo-image" />
    </div>
  </div>
</footer>


@if (footerConfig) {
<div id="st-footer-dynamic-container" class="footer-container p-0" [ngClass]="{'dark-mode': is_dark}"
  [class.t1-footer]="isTemplate1">
  @switch (isTemplate1 ? 1 : (footerConfig?.footer_template_id || 1)) {

  @case (1) {
  <!-- Layout 1: gradient bg | left: logo→contact→icons→copyright | right: nav links→powered by -->
  <div id="st-footer-template-1" class="footer-preview fp-layout-1">
    <div id="st-footer-layout1-inner-8" class="fp-l1-inner">
      <div id="st-footer-layout1-left-9" class="fp-l1-left">
        <span class="fp-logo">
          <img [src]="client_logo" alt="client_logo" />
        </span>
        @if (footerConfig?.info_config?.is_published) {
        <div id="st-footer-layout1-contact-10" class="fp-l1-contact">
          <div id="st-footer-layout1-contact-row-11" class="fp-l1-contact-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_586_5053)">
                <path
                  d="M3.93255 7.29788C5.02121 9.43739 6.77515 11.1913 8.91466 12.28L10.5779 10.6168C10.7896 10.4051 11.0844 10.3446 11.349 10.4278C12.1957 10.7075 13.103 10.8587 14.048 10.8587C14.2485 10.8587 14.4408 10.9383 14.5825 11.0801C14.7243 11.2219 14.804 11.4142 14.804 11.6147V14.2607C14.804 14.4612 14.7243 14.6535 14.5825 14.7953C14.4408 14.9371 14.2485 15.0167 14.048 15.0167C10.6394 15.0167 7.37036 13.6627 4.96011 11.2524C2.54986 8.84218 1.1958 5.57318 1.1958 2.16458C1.1958 1.96407 1.27545 1.77178 1.41723 1.63C1.55901 1.48822 1.7513 1.40857 1.95181 1.40857H4.59784C4.79835 1.40857 4.99064 1.48822 5.13242 1.63C5.2742 1.77178 5.35385 1.96407 5.35385 2.16458C5.35385 3.10959 5.50505 4.0168 5.78478 4.86353C5.86794 5.12814 5.80746 5.42298 5.59578 5.63466L3.93255 7.29788Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_586_5053">
                  <rect width="15.3092" height="15.3092" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="fp-l1-text">{{ footerConfig?.info_config?.contact_number }}</span>
          </div>
          <div id="st-footer-layout1-contact-row-12" class="fp-l1-contact-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_586_5057)">
                <path
                  d="M14.1237 5.32087L8.00005 9.14817L1.87638 5.32087V3.78995L8.00005 7.61725L14.1237 3.78995M14.1237 2.25903H1.87638C1.02672 2.25903 0.345459 2.94029 0.345459 3.78995V12.9755C0.345459 13.3815 0.506752 13.7709 0.793855 14.058C1.08096 14.3451 1.47035 14.5064 1.87638 14.5064H14.1237C14.5298 14.5064 14.9192 14.3451 15.2063 14.058C15.4934 13.7709 15.6547 13.3815 15.6547 12.9755V3.78995C15.6547 3.38393 15.4934 2.99453 15.2063 2.70743C14.9192 2.42033 14.5298 2.25903 14.1237 2.25903Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_586_5057">
                  <rect width="15.3092" height="15.3092" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="fp-l1-text">{{ footerConfig?.info_config?.email }}</span>
          </div>
        </div>
        }
        @if (footerConfig?.social_media_config?.is_published) {
        <div id="st-footer-icons-13" class="fp-icons">
          @for (link of (footerConfig?.social_media_config?.links || []); track link.order) {
          @if(link?.is_published){
          <span class="fp-icon">
            <a [href]="link?.url">
              <img [src]="link?.icon_url" alt="icon" />
            </a>
          </span>
          }}
        </div>
        }
        <p class="fp-l1-copyright"> {{ footerConfig?.about_us_config?.copyright_text || '' }}</p>
      </div>
      <div id="st-footer-layout1-right-14" class="fp-l1-right">
        <div id="st-footer-layout1-nav-15" class="fp-l1-nav">
          @if (footerConfig?.about_us_config?.is_published) {
          <span class="fp-l1-nav-link"><a [href]="footerConfig?.about_us_config?.fields?.[0]?.cta_url || ''">{{
              footerConfig?.about_us_config?.fields?.[0]?.cta_label || '' }}</a></span>
          }
          @if (footerConfig?.terms_config?.is_published) {
          @for (term of footerConfig?.terms_config?.fields || []; track term.order) {
          <span class="fp-l1-nav-link">
            <a [href]="term?.cta_url || ''">{{ term.cta_label || '' }}</a>
          </span>
          }
          }
        </div>
        <div id="st-footer-layout1-powered-16" class="fp-l1-powered">
          <span class="fp-l1-powered-text">Powered By</span>
          <span class="fp-logo fp-logo--sm"><img [src]="brand_logo_light" alt="brand_logo" /></span>
        </div>
      </div>
    </div>
  </div>
  }

  @case (2) {
  <!-- Layout 2: 3-col [logo+contact | about links 2-col | social] + copyright bar -->
  <div id="st-footer-template-2" class="footer-preview fp-layout-2">
    <div id="st-footer-layout2-main-17" class="fp-l2-main justify-content-between">
      <div id="st-footer-layout2-left-18" class="fp-l2-left d-flex flex-column gap-3">
        <span class="fp-logo"><img [src]="client_logo" alt="client_logo" /></span>
        <span class="fp-text fs-15 fw-semibold">Email: {{ footerConfig?.info_config?.email || '' }} </span>
        <span class="fp-text fs-15 fw-semibold">Phone: {{ footerConfig?.info_config?.contact_number || '' }}</span>
      </div>
      <div id="st-footer-layout2-center-19" class="fp-l2-center flex-grow-1 h-100 center-item" style="top: 2rem;">
        <div id="st-footer-layout2-center-20" class="fp-l2-center flex-grow-0">
          @if (footerConfig?.about_us_config?.is_published) {
          <span class="fp-section-title">About us</span>
          }
          <div id="st-footer-layout2-links-grid-21" class="fp-l2-links-grid mt-3">
            @if (footerConfig?.about_us_config?.is_published) {
            <span class="fp-link fs-15 fw-semibold">
              <a [href]="footerConfig?.about_us_config?.fields?.[0]?.cta_url || ''" class="fw-semibold">&rsaquo; {{
                footerConfig?.about_us_config?.fields?.[0]?.cta_label
                || ''
                }}</a>
            </span>
            }
            @for (term of footerConfig?.terms_config?.fields || []; track term.order) {
            <span class="fp-link fs-15 fw-semibold">
              <a [href]="term?.cta_url || ''" class="fw-semibold"> &rsaquo; {{ term.cta_label || '' }}</a>
            </span>
            }
          </div>
        </div>
      </div>
      @if (footerConfig?.social_media_config?.is_published) {
      <div id="st-footer-layout2-right-22" class="fp-l2-right d-flex flex-column gap-3">
        <span class="fp-section-title">Social Media</span>
        <div id="st-footer-icons-23" class="fp-icons">
          @for (link of footerConfig?.social_media_config?.links || []; track link.order) {
          @if(link?.is_published){
          <span class="fp-icon">
            <a [href]="link?.url">
              <img [src]="link?.icon_url" alt="icon" />
            </a>
          </span>
          }}
        </div>
      </div>
      }
    </div>
    <div id="st-footer-copyright-bar-24" class="fp-copyright-bar d-flex justify-content-between align-items-center gap-3 flex-wrap col-gap-3 row-gap-1"
      [ngClass]="{'secondary-bar': tenant_name  == 'switz'}">
      <p>{{ footerConfig?.about_us_config?.copyright_text || '' }}</p>
      <div id="st-footer-layout1-powered-25" class="fp-l1-powered">
        <span class="fp-l1-powered-text">Powered By</span>
        <span class="fp-logo fp-logo--sm"><img [src]="brand_logo" alt="brand_logo" /></span>
      </div>
    </div>
  </div>
  }

  @case (3) {
  <!-- Layout 3: logo+nav top row | divider | contact+copyright+icons bottom row -->
  <div id="st-footer-template-3" class="footer-preview fp-layout-3">
    <div id="st-footer-layout3-top-26" class="fp-l3-top">
      <span class="fp-logo"><img [src]="client_logo" alt="client_logo" /></span>
      <div id="st-footer-layout3-nav-27" class="fp-l3-nav d-flex align-items-center gap-3">
        @if (footerConfig?.about_us_config?.is_published) {
        <span class="fp-link fs-15 fw-semibold">
          <a [href]="footerConfig?.about_us_config?.fields?.[0]?.cta_url || ''" class="fw-semibold">{{
            footerConfig?.about_us_config?.fields?.[0]?.cta_label || ''
            }}</a>
        </span>
        }
        @for (term of footerConfig?.terms_config?.fields || []; track term.order) {
        <span class="fp-link fs-15 fw-semibold">
          <a [href]="term?.cta_url || ''" class="fw-semibold">{{ term.cta_label || '' }}</a>
        </span>
        }
      </div>
    </div>
    <hr class="fp-divider flex-grow-1">
    <div id="st-footer-layout3-bottom-28" class="fp-l3-bottom d-flex justify-content-between align-items-center gap-3">
      <div id="st-footer-layout3-contact-29" class="fp-l3-contact d-flex align-items-center gap-3 flex-wrap">
        <span class="fs-12 fw-medium">{{ footerConfig?.info_config?.email || '' }}</span>
        <span class="fs-12 fw-medium">{{ footerConfig?.info_config?.contact_number || '' }}</span>
      </div>
      <div id="st-container-30" class="d-flex align-items-center gap-3 flex-wrap center-item">
        <span class="fw-normal">{{ footerConfig?.about_us_config?.copyright_text || '' }}</span>
        <div id="st-footer-layout1-powered-31" class="fp-l1-powered">
          <span class="fp-l1-powered-text">Powered By</span>
          <span class="fp-logo fp-logo--sm"><img [src]="brand_logo_light" alt="brand_logo" /></span>
        </div>
      </div>
      @if (footerConfig?.social_media_config?.is_published) {
      <div id="st-footer-icons-32" class="fp-icons">
        @for (link of footerConfig?.social_media_config?.links || []; track link.order) {
        @if(link?.is_published){
        <span class="fp-icon">
          <a [href]="link?.url">
            <img [src]="link?.icon_url" alt="icon" />
          </a>
        </span>
        }
        }
      </div>
      }
    </div>
  </div>
  }

  @default {
  <!-- Layout 4: logo | nav links | icons single row | divider | copyright bar -->
  <div id="st-footer-template-4" class="footer-preview fp-layout-4">
    <div id="st-footer-layout4-top-33" class="fp-l4-top justify-content-between">
      <span class="fp-logo"><img [src]="client_logo" alt="client_logo" /></span>
      <div id="st-footer-layout4-nav-34" class="fp-l4-nav d-flex align-items-center justify-content-center gap-3 flex-grow-1 center-item">
        @if (footerConfig?.about_us_config?.is_published) {
        <span class="fp-link fs-15 fw-semibold">
          <a [href]="footerConfig?.about_us_config?.fields?.[0]?.cta_url || ''" class="fw-semibold">{{
            footerConfig?.about_us_config?.fields?.[0]?.cta_label || ''
            }}</a>
        </span>
        }
        @for (term of footerConfig?.terms_config?.fields || []; track term.order) {
        <span class="fp-link fs-15 fw-semibold">
          <a [href]="term?.cta_url || ''" class="fw-semibold">{{ term.cta_label || '' }}</a>
        </span>
        }
      </div>
      @if (footerConfig?.social_media_config?.is_published) {
      <div id="st-footer-icons-35" class="fp-icons">
        @for (link of footerConfig?.social_media_config?.links || []; track link.order) {
        @if(link?.is_published){
        <span class="fp-icon">
          <a [href]="link?.url">
            <img [src]="link?.icon_url" alt="icon" />
          </a>
        </span>
        }}
      </div>
      }
    </div>
    <div id="st-footer-copyright-bar-36" class="fp-copyright-bar d-flex justify-content-between align-items-center flex-wrap col-gap-3 row-gap-1">
      <div id="st-footer-layout3-contac-37" class="fp-l3-contac d-flex align-items-center gap-3">
        <span class="fs-12 fw-medium">{{ footerConfig?.info_config?.email }}</span>
        <span class="fs-12 fw-medium">{{ footerConfig?.info_config?.contact_number }}</span>
      </div>
      <p>{{ footerConfig?.about_us_config?.copyright_text || ''}}</p>
      <div id="st-footer-layout1-powered-38" class="fp-l1-powered">
        <span class="fp-l1-powered-text">Powered By</span>
        <span class="fp-logo fp-logo--sm"><img [src]="brand_logo" alt="brand_logo" /></span>
      </div>
    </div>
  </div>
  }
  }
</div>
}